import React, { useRef, useState } from "react";
import ReactPlayer from "react-player";

interface Slide {
  type: "video" | "image";
  src: string;
}

interface SellerCarouselProps {
  slides: Slide[];
  className?: string;
}

const SLIDE_WIDTH = 390;
const SLIDE_GAP = 24;

const SellerCarousel: React.FC<SellerCarouselProps> = ({ slides, className = "" }) => {
  const carouselRef = useRef<HTMLDivElement>(null);
  const [scrollIndex, setScrollIndex] = useState(0);

  return (
    <div className={`relative w-full ${className}`}>
      <div
        ref={carouselRef}
        className="no-scrollbar mx-auto mt-4 flex w-full max-w-[1650px] gap-[24px] overflow-x-auto scroll-smooth pb-4"
        style={{
          scrollSnapType: "x mandatory",
          WebkitOverflowScrolling: "touch",
        }}
      >
        {slides.map((slide, idx) =>
          slide.type === "video" ? (
            <div
              key={slide.src}
              className="relative flex h-[620px] flex-shrink-0 items-center justify-center overflow-hidden rounded-[32px] bg-[#f5f6fa]"
              style={{
                width: SLIDE_WIDTH,
                scrollSnapAlign: "start",
              }}
            >
              <ReactPlayer
                url={slide.src}
                playing
                loop
                muted
                playsinline
                controls={false}
                width="120%"
                height="135%"
                style={{ borderRadius: "32px", objectFit: "cover" }}
              />
            </div>
          ) : (
            <div
              key={slide.src}
              className="relative flex h-[620px] flex-shrink-0 items-center justify-center overflow-hidden rounded-[32px] bg-[#f5f6fa]"
              style={{
                width: SLIDE_WIDTH,
                scrollSnapAlign: "start",
              }}
            >
              <img
                src={slide.src}
                alt={`Tradefoox carousel slide ${idx + 1}`}
                className="h-full w-full rounded-[32px] object-cover"
                loading="lazy"
              />
            </div>
          ),
        )}
      </div>
      <div className="mr-28 mt-4 flex justify-end gap-4">
        <button
          onClick={() => {
            if (carouselRef.current) {
              const slideWidth = SLIDE_WIDTH + SLIDE_GAP;
              carouselRef.current.scrollLeft -= slideWidth;
              setScrollIndex(prevIndex => prevIndex - 1);
            }
          }}
          disabled={scrollIndex === 0}
          className="flex h-12 w-12 items-center justify-center rounded-full bg-gray-200 shadow hover:bg-gray-300 disabled:opacity-50"
          aria-label="Previous"
        >
          <span className="text-2xl">&#8249;</span>
        </button>
        <button
          onClick={() => {
            if (carouselRef.current) {
              const slideWidth = SLIDE_WIDTH + SLIDE_GAP;
              carouselRef.current.scrollLeft += slideWidth;
              setScrollIndex(prevIndex => prevIndex + 1);
            }
          }}
          disabled={scrollIndex === slides.length - 1}
          className="flex h-12 w-12 items-center justify-center rounded-full bg-gray-200 shadow hover:bg-gray-300 disabled:opacity-50"
          aria-label="Next"
        >
          <span className="text-2xl">&#8250;</span>
        </button>
      </div>
    </div>
  );
};

export default SellerCarousel;
